import {
  LoginType,
  type OtpStartReqInput,
  type OtpLoginResBody,
  type OtpLoginReqInput,
  type GuestLoginReqInput,
  type CorpPerkStoreGuestLoginReqInput,
} from '@/types/magicLink'
import { createApiUtils } from './utils'

const baseUrl = '/redemption/api/user/login'

type OtpResponses = {
  start: void
  verify: OtpLoginResBody
  guestLogin: OtpLoginResBody
  refresh: OtpLoginResBody
  corpPerkStoreGuestLogin: OtpLoginResBody
}

export const useOtpRepository = () => {
  const { execute, getError } = createApiUtils<OtpResponses>()

  const start = (params: OtpStartReqInput) => {
    params.loginType = params.userEmail
      ? LoginType.OTP_START
      : params.userPhoneNumber
        ? LoginType.OTP_SMS_START
        : undefined

    return {
      url: baseUrl,
      options: {
        method: 'POST',
        body: params,
      },
    } as const
  }

  const verify = (params: OtpLoginReqInput) => {
    params.loginType = params.userEmail
      ? LoginType.OTP_LOGIN
      : params.userPhoneNumber
        ? LoginType.OTP_SMS_LOGIN
        : undefined

    return {
      url: baseUrl,
      options: {
        method: 'POST',
        body: params,
      },
    } as const
  }

  const refresh = (refreshToken: string) => {
    return {
      url: `${baseUrl}/refresh`,
      options: {
        method: 'POST',
        body: {
          refreshToken,
        },
      },
    } as const
  }

  const guestLogin = (params: GuestLoginReqInput) => {
    params.loginType = LoginType.GUEST_LOGIN
    return {
      url: baseUrl,
      options: {
        method: 'POST',
        body: params,
        headers: {
          'x-zenni-store-id': params.storeId,
        },
        skipAuth: true,
      },
    } as const
  }

  const corpPerkStoreGuestLogin = (params: CorpPerkStoreGuestLoginReqInput) => {
    params.loginType = LoginType.CORP_PERK_STORE_GUEST_LOGIN
    return {
      url: baseUrl,
      options: {
        method: 'POST',
        body: params,
        headers: {
          'x-zenni-store-id': params.storeId,
        },
      },
    } as const
  }

  return {
    start,
    verify,
    refresh,
    guestLogin,
    corpPerkStoreGuestLogin,
    execute,
    getError,
  }
}
